/**
 * 已上传文件列表
 * @filename src/pages/chatArea/chatBox/ChatBoxFooter/ImChat/UploadedFileList/index.tsx
 * @author  tujiawei <jiaweitu@marchthepolo.com>
 * @date 2024-07-31 17:29:54
 */

import { NormalCloseIcon } from '@/components/SvgIcon'
import { LoadingOutlined } from '@ant-design/icons'
import { FC } from 'react'

const UploadedFileList: FC<{
	loading: boolean
	pf: any[]
	deleteFile: (file: any) => () => void
}> = ({ loading, pf, deleteFile }) => {
	return (
		<>
			<style>{`
				.uploaded-file-list::-webkit-scrollbar {
					display: none;
				}
			`}</style>
			<div
				className="uploaded-file-list flex item-center bg-white gap-2 pl-2 overflow-x-auto mb-[2px]"
				style={{
					scrollbarWidth: 'none',
					msOverflowStyle: 'none'
				}}
			>
				{pf.map(f => (
					<div key={f.url} className="bg-[#F2F3F5] p-1 flex items-center rounded text-xs">
						<div
							className="flex items-center cursor-pointer"
							onClick={() => {
								window.open(f.url)
							}}
						>
							<div className="max-w-[80px] truncate">{`${f.name}`}</div>
							{`(${f.size})`}
						</div>
						<div className="h-5 cursor-pointer" onClick={deleteFile(f)}>
							{NormalCloseIcon}
						</div>
					</div>
				))}
				{loading ? <LoadingOutlined /> : null}
			</div>
		</>
	)
}

export default UploadedFileList
